/**
 * Libraries provided by TAL to consuming apps.
 */

window["React"] = require("react");
window["ReactDOM"] = require("react-dom");
window["styled"] = require("styled-components");
